import { TRELLO_TOKEN_KEY } from "../config"

export async function getAuthorizationStatus(t: TrelloIframe) {
  const token = await t.get("member", "private", TRELLO_TOKEN_KEY)
  const authorized = typeof token === "string" && Boolean(token) && !token.includes("error")
  return { authorized }
}
